<main
    class="agpr-mentionImporter agpr-mentionImporter-container"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <section
        class="agpr-mentionImporter-center"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <div class="agpr-mentionImporter-header">
            <span
                class="agpr-mentionImporter-header-main"
                tabindex="-1"
            >
                {{ 'Monitoring.result.importMentions' | localize }}
            </span>
            <div
                *ngIf="csvFiles.length > 0"
                class="agpr-mentionImporter-header-tip"
            >
                <span> * </span>
                <span>{{ 'Monitoring.mentionImporter.required' | localize }}</span>
            </div>
        </div>
        <div
            *ngIf="csvFiles.length === 0 && !loading"
            class="agpr-hype-container"
        >
            <span class="agpr-i-line-import-mentions agpr-hype-bigIcon" aria-hidden="true"></span>
            <div class="agpr-hype-text">{{ 'Monitoring.mentionImporter.hype.line1' | localize}}</div>
            <div class="agpr-hype-text">{{ 'Monitoring.mentionImporter.hype.line2' | localize}}</div>
            <div class="agpr-hype-text">
                <a
                    href="http://help.agilitypr.com/en"
                    target="_blank"
                    class="agpr-hype-text"
                >
                    {{ 'Monitoring.mentionImporter.hype.link' | localize }}</a>{{ 'Monitoring.mentionImporter.hype.line3' | localize }}
            </div>
            <div class="agpr-hype-fileSelect">
                <agpr-dropdown
                    [id]="'mentionImporter_fileTypeDropdown'"
                    label="Monitoring.mentionImporter.fileTypeDropdown.label"
                    placeholder="Monitoring.mentionImporter.fileTypeDropdown.placeholder"
                    [options]="importTypeOptions"
                    [(ngModel)]="selectedImportType"
                    (ngModelChange)="resetImportTypes()"
                ></agpr-dropdown>
                <agpr-file-upload
                    #fileUpload
                    *ngIf="selectedImportType"
                    [id]="'mentionImport_fileUpload'"
                    [ngClass]="{ 'agpr-hype--noTypeSelected': !selectedImportType }"
                    [maxFiles]="FILE_LIMIT"
                    [supportedFileTypesRegex]="fileTypesMap.get(selectedImportType.value).fileTypesRegex"
                    [supportedFileTypes]="fileTypesMap.get(selectedImportType.value).fileTypes"
                    header="Monitoring.mentionImporter.uploadFile.label"
                    uploadButtonLabel="Monitoring.mentionImporter.uploadFile.buttonLabel"
                    [disabled]="!selectedImportType"
                    [uppercaseHeader]="false"
                    (onAdd)="filesAdded($event)"
                    (onRemove)="fileRemoved($event)"
                    (onValidationError)="fileValidationErrors($event)"
                    [holdFileData]="true"
                    [validationFunction]="validateFileEncoding"
                ></agpr-file-upload>
            </div>
        </div>
        <div
            *ngIf="loading"
            class="agpr-loading"
        >
            <span class="agpr-i-line-import-mentions agpr-loading-importIcon" aria-hidden="true"></span>
            <div class="agpr-loading-progressBar">
                <span class="agpr-loading-title"> {{ 'Monitoring.mentionImporter.loading.header' | localize }} </span>
                <p-progressBar
                    [value]="((progress?.currentIndex / progress?.totalItems) * 100)"
                    [showValue]="false"
                ></p-progressBar>
                <span class="agpr-loading-counter"> {{ (((progress?.currentIndex / progress?.totalItems) * 100) || 0) | number: '1.0-0' }} %</span>
            </div>
            <div class="agpr-loading-message">
                <agpr-message
                    [severity]="messageSeverities.warning"
                >
                    <div class="agpr-loading-message-header">
                        {{ 'Monitoring.mentionImporter.loading.warning.header' | localize }}
                    </div>

                    <div class="agpr-loading-message-body">
                        {{ 'Monitoring.mentionImporter.loading.warning.body' | localize }}
                    </div>
            </agpr-message>
            </div>
        </div>
        <div
            *ngIf="csvFiles.length > 0"
            class="agpr-filetabs-container"
        >
            <agpr-tabs>
                <ng-template #tabTemplate let-tab="tab">
                    <div
                        class="agpr-filetabs-tab"
                        [pTooltip]="tab.heading"
                        tooltipPosition="top"
                    >
                        {{tab.heading}}
                    </div>
                </ng-template>

                <agpr-tab
                    *ngFor="let file of csvFiles; let fileIndex = index"
                    [heading]="file.fileName"
                    [id]="'mentionImport.tab' + fileIndex"
                >
                    <agpr-scroll-panel>
                        <div
                            *ngIf="file.csvColumns && file.csvFields"
                            role="grid"
                            class="agpr-fieldlist-container"
                            [attr.aria-label]="file.fileName"
                        >
                            <div
                                role="row"
                                class="agpr-fieldlist-gridContainer agpr-fieldlist-header"
                            >
                                <span
                                    role="columnheader"
                                    class="agpr-fieldlist-headerLabels"
                                >
                                    {{ 'Monitoring.mentionImporter.csvColumnHeader.mentionFields' | localize }}
                                </span>
                                <span
                                    role="columnheader"
                                    class="agpr-fieldlist-headerLabels"
                                >
                                    {{ 'Monitoring.mentionImporter.csvColumnHeader.csvColumn' | localize }}
                                </span>
                                <span
                                    role="columnheader"
                                    class="agpr-fieldlist-headerLabels"
                                >
                                    {{ 'Monitoring.mentionImporter.csvColumnHeader.preview' | localize }}
                                </span>
                                <span
                                    role="columnheader"
                                    class="agpr-fieldlist-headerLabels"
                                >
                                    {{ 'Monitoring.mentionImporter.csvColumnHeader.fallbackValue' | localize }}
                                    <span
                                        role="img"
                                        class="fa-regular fa-circle-info"
                                        agprTooltip="Monitoring.mentionImporter.csvColumnHeader.fallbackValue.tooltip"
                                    ></span>
                                </span>
                            </div>
                            <div
                                *ngFor="let field of file.csvFields; let fieldIndex = index"
                                role="row"
                                class="agpr-greyLine"
                            >
                                <div class="agpr-fieldlist-gridContainer">
                                    <span
                                        role="rowheader"
                                        id="fileIndex + '-mentionFieldName-' + fieldIndex"
                                        class="agpr-fieldlist-fieldLabels"
                                    >
                                        <span>{{ field.originalField.label }}</span>
                                        <span
                                            *ngIf="field.originalField.required"
                                            class="agpr-requiredAsterix"
                                        > *</span>
                                    </span>
                                    <span
                                        role="gridcell"
                                        class="agpr-fieldlist-fieldDropdowns"
                                    >
                                         <agpr-dropdown
                                            [id]="'csvimport.' + fileIndex + '.field.' + field.originalField.fieldId + '.dropdown'"
                                            [options]="csvColumnDropdownOptions[fileIndex]"
                                            placeholder="Discover.contactImporter.placeholders.input"
                                            panelStyleClass="agpr-mentionImporter-csvColumnDropdown"
                                            [ariaLabel]="field.originalField.label"
                                            [ariaDescribedBy]="field.requiredError ? 'mentionImporter_' + field.originalField.fieldId + '_requiredFieldErrorMessage' : null"
                                            [ariaRequired]="field.originalField.required"
                                            [(ngModel)]="selectedOptions[fileIndex][fieldIndex]"
                                            (ngModelChange)="onDropdownChanged($event, file, field)"
                                        ></agpr-dropdown>
                                    </span>
                                    <div
                                        role="gridcell"
                                        class="agpr-fieldlist-preview"
                                    >
                                        <span
                                            *ngIf="field.exampleValue && !field.originalField.dateValidationFormatDropdownOptions && !field.originalField.timeValidationFormatDropdownOptions"
                                            role="gridcell"
                                            class="agpr-fieldlist-fieldExamples"
                                            [agprTooltip]="field.exampleValue"
                                            tooltipPosition="top"
                                        >
                                            {{ field.exampleValue }}
                                        </span>
                                        <agpr-dropdown
                                            *ngIf="field.exampleValue && field.originalField.dateValidationFormatDropdownOptions"
                                            [options]="field.originalField.dateValidationFormatDropdownOptions"
                                            placeholder="Monitoring.mentionImporter.selectDateFormat"
                                            [ariaLabel]="field.originalField.label"
                                            [ariaDescribedBy]="'dateValidationFormatDropdown_' + fieldIndex + '_error'"
                                            [(ngModel)]="field.selectedDateValidationFormat"
                                            (ngModelChange)="selectDateTimeValidationFormat(field)"
                                        ></agpr-dropdown>
                                        <agpr-dropdown
                                            *ngIf="field.exampleValue && field.originalField.timeValidationFormatDropdownOptions"
                                            [options]="field.originalField.timeValidationFormatDropdownOptions"
                                            placeholder="Monitoring.mentionImporter.selectTimeFormat"
                                            [ariaLabel]="field.originalField.label"
                                            [ariaDescribedBy]="'timeValidationFormatDropdown_' + fieldIndex + '_error'"
                                            [(ngModel)]="field.selectedTimeValidationFormat"
                                            (ngModelChange)="selectDateTimeValidationFormat(field)"
                                        ></agpr-dropdown>
                                        <span
                                            *ngIf="!field.exampleValue && selectedOptions[fileIndex][fieldIndex]?.value?.columnIndex === null"
                                            role="gridcell"
                                            class="agpr-fieldlist-fieldExamples-placeholder"
                                        >
                                            {{ 'Monitoring.mentionImporter.exampleValue.placeholder.preview' | localize }}
                                        </span>
                                        <span
                                            *ngIf="!field.exampleValue && selectedOptions[fileIndex][fieldIndex]?.value?.columnIndex !== null"
                                            role="gridcell"
                                            class="agpr-fieldlist-fieldExamples-placeholder"
                                        >
                                            {{ 'Monitoring.mentionImporter.exampleValue.placeholder.noData' | localize }}
                                        </span>
                                    </div>
                                    <span
                                        [ngSwitch]="field.originalField.fallbackInputType"
                                        rolw="gridcell"
                                        class="agpr-fieldlist-fieldFallbacks"
                                    >
                                        <ng-container>
                                            <agpr-text-input
                                                *ngSwitchCase="fallbackInputTypes.text"
                                                [id]="fileIndex + '_' + field.originalField.fieldId + '_fallbackValueTextInput'"
                                                [bottomMargin]="false"
                                                placeholder="Monitoring.mentionImporter.fallbackValue.textPlaceholder"
                                                [maxLength]="field.originalField.maxLength ? field.originalField.maxLength : null"
                                                [ariaDescribedBy]="'fallbackValueField_' + fieldIndex + '_error'"
                                                [(ngModel)]="field.fallbackValue"
                                                (ngModelChange)="validateFallbackTextField(field)"
                                            ></agpr-text-input>
                                            <agpr-form-message
                                                *ngIf="field.fallbackValueError"
                                                [id]="'fallbackValueField_' + fieldIndex + '_error'"
                                            >
                                                {{ field.originalField.fallbackValueErrorMessage | localize }}
                                            </agpr-form-message>
                                        </ng-container>
                                        <div
                                            *ngSwitchCase="fallbackInputTypes.dateTime"
                                            class="agpr-fieldlist-dateTime"
                                        >
                                            <agpr-date-picker
                                                [id]="fileIndex + '_' + field.originalField.fieldId + '_publishedDateTimeCalendar'"
                                                [(ngModel)]="field.fallbackValue.date"
                                            ></agpr-date-picker>
                                            <agpr-time-picker
                                                [id]="fileIndex + '_' + field.originalField.fieldId + '_timePicker'"
                                                [(ngModel)]="field.fallbackValue.time"
                                                [showTimeZoneSelector]="false"
                                            ></agpr-time-picker>
                                        </div>
                                        <div
                                            *ngSwitchCase="fallbackInputTypes.date"
                                            class="agpr-fieldlist-date"
                                        >
                                            <agpr-date-picker
                                                [id]="fileIndex + '_' + field.originalField.fieldId + '_publishedDateCalendar'"
                                                [(ngModel)]="field.fallbackValue"
                                                (ngModelChange)="field.requiredError = false"
                                            ></agpr-date-picker>
                                        </div>
                                        <agpr-time-picker
                                            *ngSwitchCase="fallbackInputTypes.time"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_publishedTimeTimePicker'"
                                            [(ngModel)]="field.fallbackValue"
                                            [showTimeZoneSelector]="false"
                                        ></agpr-time-picker>
                                        <agpr-time-picker
                                            *ngSwitchCase="fallbackInputTypes.duration"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_durationPicker'"
                                            [durationMode]="true"
                                            [showHour]="false"
                                            [showSecond]="true"
                                            [(ngModel)]="field.fallbackValue"
                                        ></agpr-time-picker>
                                        <agpr-dropdown
                                            *ngSwitchCase="fallbackInputTypes.dropdown"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_dropdown'"
                                            [(ngModel)]='field.fallbackValue'
                                            placeholder="Monitoring.mentionImporter.fallbackValue.dropdownPlaceholder"
                                            [options]="field.originalField.fallbackDropdownOptions"
                                        ></agpr-dropdown>
                                        <agpr-number-input
                                            *ngSwitchCase="fallbackInputTypes.number"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_numberInput'"
                                            [min]="0"
                                            [max]="field.originalField.max"
                                            [step]="field.originalField.step"
                                            [integerOnly]="field.originalField.integerOnly"
                                            [bottomMargin]="false"
                                            [placeholder]="field.originalField.placeholder"
                                            [(ngModel)]="field.fallbackValue"
                                        ></agpr-number-input>
                                        <agpr-autocomplete
                                            *ngSwitchCase="fallbackInputTypes.autocomplete"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_autocomplete'"
                                            [(ngModel)]="field.fallbackValue"
                                            placeholder="Monitoring.mentionImporter.fallbackValue.autocompletePlaceholder"
                                            [forceSelection]="false"
                                            [clearOnBlur]="false"
                                            [suggestionsFetcher]="field.originalField.fallbackSuggestionsFetcher"
                                        ></agpr-autocomplete>
                                        <agpr-timezone-picker
                                            *ngSwitchCase="fallbackInputTypes.timezone"
                                            [id]="fileIndex + '_' + field.originalField.fieldId + '_timezone'"
                                            [(ngModel)]="field.fallbackValue"
                                        ></agpr-timezone-picker>
                                    </span>
                                </div>
                                <agpr-form-message
                                    *ngIf="field.requiredError"
                                    [id]="'mentionImporter_' + field.originalField.fieldId + '_requiredFieldErrorMessage'"
                                >
                                    {{ field.originalField.label }}{{ 'Monitoring.mentionImporter.fieldRequired' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="field.dateValidationFormatRequiredError"
                                    [id]="'dateValidationFormatDropdown_' + fieldIndex + '_error'"
                                >
                                    {{ 'Monitoring.mentionImporter.dateValidationFormatRequired' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="field.timeValidationFormatRequiredError"
                                    [id]="'timeValidationFormatDropdown_' + fieldIndex + '_error'"
                                >
                                    {{ 'Monitoring.mentionImporter.timeValidationFormatRequired' | localize }}
                                </agpr-form-message>
                            </div>
                        </div>
                    </agpr-scroll-panel>
                </agpr-tab>
            </agpr-tabs>
        </div>

        <agpr-action-bar *ngIf="!loading">
            <ng-template #left>
                <agpr-button
                    *ngIf="overlayMode"
                    [id]="'mentionImport_cancelButton'"
                    label="cancel"
                    [style]="buttonTypes.secondary"
                    (click)="closeImporter()"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                <agpr-button
                    *ngIf="(selectedImportType?.value === importTypes.GENERIC_CSV || selectedImportType?.value === importTypes.CISION) && csvFiles.length > 0"
                    [id]="'mentionImport_importCsvButton'"
                    label="Monitoring.mentionImporter.importCsvButton"
                    [style]="buttonTypes.primary"
                    (click)="importCsv()"
                ></agpr-button>
                <agpr-button
                    *ngIf="csvFiles.length === 0"
                    [id]="'mentionImport_importButton'"
                    label="Monitoring.mentionImporter.importButton"
                    [disabled]="selectedFiles.length === 0 || !hasValidMentions || noReportEmailError"
                    [style]="buttonTypes.primary"
                    [tooltip]="selectedImportType ?
                        (selectedFiles.length === 0 ? 'Monitoring.mentionImporter.importButton.fileRequired':
                            (!hasValidMentions ? 'Monitoring.mentionImporter.importButton.noValidMentions' : (
                                noReportEmailError ? 'Monitoring.mentionImporter.reportRecipient.required' : null
                            ))
                        )
                        : 'Monitoring.mentionImporter.importButton.fileTypeRequired'"
                    ariaLabel="Monitoring.mentionImporter.importButton"
                    tooltipPosition="top"
                    [ariaDescribedBy]="!selectedImportType || selectedFiles.length === 0 || !hasValidMentions ? 'mentionImport_importButton_disabledDescription' : null"
                    (click)="importMentions()"
                ></agpr-button>
                <span
                    *ngIf="!selectedImportType || selectedFiles.length === 0"
                    id="mentionImport_importButton_disabledDescription"
                    class="u-srOnly"
                >
                    {{ (selectedImportType ?
                        (selectedFiles.length === 0 ? 'Monitoring.mentionImporter.importButton.fileRequired':
                            (!hasValidMentions ? 'Monitoring.mentionImporter.importButton.noValidMentions' : (
                                noReportEmailError ? 'Monitoring.mentionImporter.reportRecipient.required' : null
                            ))
                        )
                        : 'Monitoring.mentionImporter.importButton.fileTypeRequired') | localize
                    }}
                </span>
            </ng-template>
        </agpr-action-bar>
    </section>
    <aside
        *ngIf="!loading"
        class="agpr-mentionImporter-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar>
            <agpr-panel
                *ngIf="csvFiles.length > 0"
                header="Monitoring.mentionImporter.uploadedFiles"
                [toggleable]="false"
            >
                <span
                    *ngFor="let file of csvFiles"
                    class="agpr-mentionImporter-sidebar-uploadedFile"
                >
                    {{ file.fileName }}
                </span>
            </agpr-panel>
            <agpr-panel
                header="Monitoring.mentionImporter.importOptions"
                [toggleable]="false"
                class="agpr-mentionImporter-importOptions"
            >
                <agpr-autocomplete
                    [id]="'mentionImporter_folderSelector'"
                    labelField="name"
                    label="Monitoring.mentionImporter.importOptions.importToFolders"
                    placeholder="Monitoring.mentionImporter.importOptions.importToFolders.placeholder"
                    [ngClass]="{ 'agpr-mentionImporter-importOptions-inputField--hasChips': fileParameters.folders.length > 0 }"
                    [dropdown]="true"
                    [suggestions]="folderList$"
                    [(ngModel)]="dropdownFolder"
                    [customOptions]="folderAutocompleteOptions"
                    (clear)="dropdownFolder = null"
                    (itemSelected)="importFilesToCollection($event, importToCollectionTypes.folders)"
                ></agpr-autocomplete>
                <ul
                    *ngIf="fileParameters.folders.length > 0"
                    class="agpr-chips-list"
                >
                    <li
                        *ngFor="let folder of fileParameters.folders"
                        class="agpr-chip"
                    >
                        <span class="agpr-chip-label">
                            {{ folder.name }}
                        </span>
                        <span
                            class="agpr-chip-icon agpr-i-close"
                            (click)="removeCollection(folder, importToCollectionTypes.folders)"
                            aria-hidden="true"
                        >
                        </span>
                    </li>
                </ul>

                <agpr-autocomplete
                    [id]="'mentionImporter_tagSelector'"
                    labelField="name"
                    label="Monitoring.mentionImporter.importOptions.importToTags"
                    placeholder="Monitoring.mentionImporter.importOptions.importToTags.placeholder"
                    [ngClass]="{ 'agpr-mentionImporter-importOptions-inputField--hasChips': fileParameters.tags.length > 0 }"
                    [dropdown]="true"
                    [suggestions]="tagList$"
                    [(ngModel)]="dropdownTag"
                    [customOptions]="tagAutocompleteOptions"
                    (clear)="dropdownTag = null"
                    (itemSelected)="importFilesToCollection($event, importToCollectionTypes.tags)"
                ></agpr-autocomplete>
                <ul
                    *ngIf="fileParameters.tags.length > 0"
                    class="agpr-chips-list"
                >
                    <li
                        *ngFor="let tag of fileParameters.tags"
                        class="agpr-chip"
                    >
                        <span class="agpr-chip-label">
                            {{ tag.name }}
                        </span>
                        <span
                            class="agpr-chip-icon agpr-i-close"
                            (click)="removeCollection(tag, importToCollectionTypes.tags)"
                            aria-hidden="true"
                        >
                        </span>
                    </li>
                </ul>
                <ng-container *ngIf="selectedImportType?.value === importTypes.GENERIC_CSV">
                    <ng-container *ngIf="hasImportToMercury">
                        <agpr-checkbox
                            [id]="'mentionImporter_importToSysCheckbox'"
                            label="Monitoring.mentionImporter.importOptions.importToSystemCollection"
                            [binary]="true"
                            infoCircleTooltip="Monitoring.mentionImporter.importOptions.importToSystemCollection.tooltip"
                            [(ngModel)]="parameters.importToSystemCollection"
                            (ngModelChange)="csvImportDialogService.updateUrlRequired($event, csvFiles)"
                        ></agpr-checkbox>
                        <agpr-message
                            *ngIf="parameters.importToSystemCollection"
                            [severity]="messageSeverities.warning"
                        >
                            <p>{{ 'Monitoring.mentionImporter.importOptions.importToSystemCollection.warning' | localize }}</p>
                        </agpr-message>
                    </ng-container>
                    <agpr-checkbox
                        [id]="'mentionImporter_matchToAgilityCheckbox'"
                        label="Monitoring.mentionImporter.importOptions.matchToAgility"
                        [binary]="true"
                        infoCircleTooltip="Monitoring.mentionImporter.importOptions.matchToAgility.tooltip"
                        [(ngModel)]="parameters.matchToAgility"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        [id]="'mentionImporter_syncWithJournodexCheckbox'"
                        label="Monitoring.mentionImporter.importOptions.syncWithJournodex"
                        [binary]="true"
                        infoCircleTooltip="Monitoring.mentionImporter.importOptions.syncWithJournodex.tooltip"
                        [(ngModel)]="parameters.syncWithJournodex"
                    ></agpr-checkbox>
                </ng-container>
            </agpr-panel>
            <agpr-panel
                header="Monitoring.mentionImporter.reportRecipient.header"
                tooltip="Monitoring.mentionImporter.reportRecipient.tooltip"
                [toggleable]="false"
            >
                <agpr-email-chips
                    [id]="'confirmationRecipients_chips'"
                    [(value)]="parameters.reportDestinationEmails"
                    (valueChange)="noReportEmailError = false"
                    placeholder="Monitoring.mentionImporter.reportRecipient.placeholder"
                    errorMessage="Monitoring.mentionImporter.reportRecipient.errormessage"
                ></agpr-email-chips>
                <agpr-form-message *ngIf="noReportEmailError">
                    {{ 'Monitoring.mentionImporter.reportRecipient.required' | localize }}
                </agpr-form-message>
            </agpr-panel>
        </agpr-right-sidebar>
    </aside>
</main>
